import { STATE_KEY } from './constants';

export const SET_PERFORMANCES = `${STATE_KEY}/SET_PERFORMANCES`;
export const SET_PERFORMANCE_ATTRIBUTES = `${STATE_KEY}/SET_PERFORMANCE_ATTRIBUTES`;
export const SET_PERFORMANCE_MODAL_DATA = `${STATE_KEY}/SET_PERFORMANCE_MODAL_DATA`;
